module.exports = __webpack_public_path__ + "img/pinggu_bg.6d2e5a60.png";